import ApolloWithCognito from 'components/Apollo/ApolloWithCognito';
import Msal from 'components/Msal/Msal';
import { BrowserRouter } from 'react-router-dom';
import DrawerProvider from 'v2/components/Drawer/DrawerProvider';
import AppLocalizationProvider from 'v2/components/LocalizationProvider/AppLocalizationProvider';
import ModalProvider from 'v2/components/Modal/ModalProvider';
import SnackbarProvider from 'v2/components/Snackbar/SnackbarProvider';
import ThemeModeProvider from 'v2/components/ThemeMode/ThemeModeProvider';
import Loading from 'v2/layout/Loading/Loading';
import Router from 'v2/Router';

const App = () => {
  return (
    <BrowserRouter>
      <ThemeModeProvider>
        <Msal LoadingScreen={Loading}>
          <ApolloWithCognito>
            <AppLocalizationProvider>
              <SnackbarProvider>
                <ModalProvider>
                  <DrawerProvider>
                    <Router />
                  </DrawerProvider>
                </ModalProvider>
              </SnackbarProvider>
            </AppLocalizationProvider>
          </ApolloWithCognito>
        </Msal>
      </ThemeModeProvider>
    </BrowserRouter>
  );
};

export default App;
